import * as React from "react";
import {createElement as h} from "react";

import "./products-route.scss";

import {Helmet}                           from "@Common/libs/helmet/helmet";
import {cs}                               from "@Common/react/chain-services";
import {consumeContext}                   from "@Common/react/context";
import {Load}                             from "@Common/react/load";
import {rLsStore}                         from "@Common/react/ls-store";
import {QueryNumberArray}                 from "@Common/react/query-number-array";
import {UseState}                         from "@Common/react/use-state";
import {Responsive}                       from "@Common/ui-components/responsive";
import {flatten1, isEmpty, reverse, sort} from "@Common/utils/collections";
import {chain}                            from "@Common/utils/fs";

import {Breadcrumbs}      from "../common/breadcrumbs/breadcrumbs";
import {StyleFilter}      from "../common/components/style-filter/style-filter";
import {TemplateListMode} from "../common/components/template-list-mode/template-list-mode";
import {rTemplates}       from "../common/components/templates/templates";
import {Layout}           from "../layout/layout";
import {MatchCat}         from "../sub-category-list/sub-category-list-route";

import {SubHeader}   from "./sub-header/sub-header";

const templatesPerLoad = 50;
export const ProductsRoute = ({match}) => cs(
    consumeContext("apis"),
    consumeContext("catSubStyle"),
    consumeContext("routerHistory"),
    consumeContext("session"),
    consumeContext("userLevels"),
    ["catSubStyle", ({catSubStyle}, next) => next(catSubStyle?.value)],
    ["cat", ({catSubStyle, routerHistory}, next) => <MatchCat {...{catSubStyle, routerHistory, next, match}}/>],
    ["more", (_, next) => UseState({
        initValue: templatesPerLoad,
        next,
    })],
    ["styleTemplates", ({apis, session}, next) => <Load {...{
        _key: JSON.stringify(session.value) + match.params.sub_id,
        fetch: () => apis.next.getStyleTemplate([match.params.sub_id]),
        next,
    }}/>],
    ["filter", (_, next) => h(QueryNumberArray, {
        param: "filter",
        next,
    })],
    ["reversed", (_, next) => UseState({
        next,
    })],
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            md: 1024,
        },
        next,
    }}/>],
    ["viewMode", ({responsive}, next) => responsive.lt("md") ? next({value: "large"}) : rLsStore("tiles.viewMode", "medium")({}, next)],
    consumeContext("themeScheme"),
    ({cat, catSubStyle, styleTemplates, filter, reversed, viewMode, more, themeScheme, userLevels}) => {
        const sub = cat && cat.child.find((sub) => sub.id == match.params.sub_id);
        styleTemplates?.length > 0 && (styleTemplates = userLevels?.listSelected ? styleTemplates?.filter((style) => style.isAddressable) : styleTemplates);

        const filteredTemplates = styleTemplates && flatten1(
            Object.keys(styleTemplates)
                .filter((styleId) => isEmpty(filter.value) || filter.value.find((filterStyleId) => filterStyleId == styleId) != null)
                .map((styleId) => styleTemplates[styleId].templates)
        ) || [];

        return (<>
            <Helmet title={
                themeScheme.companyName === 'Xpressdocs' ? (
                    "Xpressdocs"
                ) : (
                    `${themeScheme.companyName} | ${
                        cat && cat.name
                    } | ${
                        sub && sub.name
                    } | Xpressdocs`
                )
            }>
                <meta name="keywords" content={`${
                    themeScheme.companyName.split(' ').join(',')
                },${
                    cat ? cat.name.split(' ').join(',') : ""
                },${
                    sub ? sub.name.split(' ').join(',') : ""
                },Xpressdocs`.replace(/[^a-zA-Z0-9]+/g, ',')}/>
            </Helmet>
            <Layout className="products-route-36e" active="catSubcatStyle">
                <div className="restrict-width-1">

                    <Breadcrumbs
                        cat={{
                            name: cat && cat.name,
                            id: match.params.cat_id,
                        }}
                        sub={{
                            name: sub && sub.name,
                            id: match.params.sub_id,
                        }}
                    />

                    <div className="controls">
                        <StyleFilter {...{
                            items: sub && sub.child.map((style) => {
                                const selected = filter.value && ~filter.value.indexOf(style.id);
                                return ({
                                    label: style.name,
                                    selected,
                                    onClick: () => filter.onChange(!selected ? [
                                        ...filter.value || [],
                                        style.id,
                                    ] : filter.value.filter((i1) => i1 !== style.id)),
                                });
                            }),
                            count: filteredTemplates.length,
                            reversed,
                            onClear: () => filter.onChange(null),
                        }}/>

                        <div className="view-modes">
                            {TemplateListMode(viewMode)}
                        </div>
                    </div>

                    {SubHeader({sub})}

                    {!catSubStyle ? (
                        <div className="" xd-qa-type="label" xd-qa-name="Loading">
                            Loading...
                        </div>
                    )  : !cat || !sub ? (
                        <div className="" xd-qa-type="label" xd-qa-name="Empty">
                            No templates are available in this category!
                        </div>
                    ) : <>
                        {rTemplates(
                            chain(
                                filteredTemplates,
                                // @ts-ignore
                                (_) => sort(_, (t) => t.seq),
                                (_) => userLevels?.listSelected ? _.filter((template) => template.isAddressable) : _,
                                (_) => userLevels?.listType == 6 ? _.filter((template) => template.isNdm) : _,
                                (_) => reversed.value ? reverse(_) : _,
                                (_) => _.slice(0, more.value),
                            ),
                            {subId: () => match.params.sub_id, mode: viewMode.value, catId: () => match.params.cat_id}
                        )}
                        {more.value < filteredTemplates.length && (
                            <div className="load-more">
                                <button
                                    onClick={()=> more.change(v=>v+templatesPerLoad)}
                                >
                                    Load More
                                </button>
                            </div>
                        )}
                    </>}
                </div>
            </Layout>
        </>);
    },
);

